import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { ReactNode, useState } from 'react';

import LoadingContext from './context/LoadingContext';

type Props = { children: ReactNode };

const LoadingContextProvider = ({ children }: Props) => {
	const [isEnable, setIsEnable] = useState<boolean>(false);

	const enable = () => {
		setIsEnable(true);
	};

	const disable = () => {
		setIsEnable(false);
	};

	const value = { isEnable, enable, disable };

	return (
		<LoadingContext.Provider value={value}>
			<Spin
				style={{ minHeight: '100vh' }}
				indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
				tip="Загрузка..."
				spinning={isEnable}
			>
				{children}
			</Spin>
		</LoadingContext.Provider>
	);
};

export default LoadingContextProvider;
